// extracted by mini-css-extract-plugin
module.exports = {"root":"_99551c8aa8--root--yeqHV"};